import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_URL, withCredentials: true });

let memToken = null;
export const setAuthToken = (t) => { memToken = t; };

api.interceptors.request.use((cfg) => {
  if (memToken) cfg.headers.Authorization = `Bearer ${memToken}`;
  return cfg;
});

export const imgSrc = (p) => (!p ? "" : /^https?:\/\//.test(p) ? p : `${API_URL}/files/${p}`);

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Coś poszło nie tak. Spróbuj ponownie.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d.msg || d);
}

export const zl = (n) => `${Number(n || 0).toLocaleString("pl-PL")} zł`;
